import styled, { css } from 'styled-components';
import { colors, cssfonts, pxToCssFont, pxToRem } from '@vfit/shared/themes';
import { IOneNumberInputForStyledComponents } from './oneNumberInput.models';
import { IOtpInputForStyledComponents } from '../../otpInput.models';

const variants = {
  input: {
    sunrise: css<IOtpInputForStyledComponents>`
      ${cssfonts.exbold}
      ${pxToCssFont(24, 28)}
      border-color: ${colors.$262626};
      width: ${pxToRem(24)};
    `,
    mva: css<IOtpInputForStyledComponents>`
      ${cssfonts.regular}
      ${pxToCssFont(18, 28)}
      border-color: ${({ error }) => (error ? `${colors.$bd0000}` : `${colors.$262626}`)};
      width: ${pxToRem(27)};
      ${({ error }) => (error ? `color: ${colors.$bd0000}` : '')}
    `,
  },
};

export const Input = styled.input<IOneNumberInputForStyledComponents>`
  border-radius: 0;
  border-style: solid;
  border-width: 0 0 1px;
  height: ${pxToRem(28)};
  overflow: hidden;
  padding: 0;
  text-align: center;

  &::placeholder {
    opacity: 0;
  }

  &:placeholder-shown {
    border-color: ${colors.$bebebe};
  }

  &:focus {
    outline: none;
    border-color: ${colors.$262626};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  &[type='number'] {
    appearance: textfield;
  }

  ${({ variant }) => (variant ? variants.input[variant] : '')}
`;

